import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { toRefs } from 'vue';
import { useRouter } from 'vue-router';
import ExcursionDesktop from './ExcursionDesktop.vue';
import ExcursionMobile from './ExcursionMobile.vue';
import { useGlobalStore } from '@/stores/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'Excursion',
  setup(__props) {

const { isMobile } = toRefs(useGlobalStore());
const router = useRouter();

const id = +router.currentRoute.value.params.id;

return (_ctx: any,_cache: any) => {
  return (_unref(isMobile))
    ? (_openBlock(), _createBlock(ExcursionMobile, {
        key: 0,
        id: id
      }))
    : (_openBlock(), _createBlock(ExcursionDesktop, {
        key: 1,
        id: id
      }))
}
}

})